import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import AppHeader from "@/components/AppHeader";
import Footer from "@/components/Footer";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <AppHeader currentPage="" />
      <main className="flex-1 pt-20 pb-24 px-4">
        <div className="max-w-7xl mx-auto flex flex-col items-center justify-center min-h-[60vh]">
          <div className="bg-card/80 backdrop-blur-sm p-8 rounded-xl border border-border/30 shadow-soft text-center max-w-md space-y-4">
            <h1 className="text-6xl font-bold text-primary">404</h1>
            <p className="text-xl text-foreground">Page not found</p>
            <p className="text-muted-foreground">The page you're looking for doesn't exist.</p>
            <Button onClick={() => navigate("/dashboard")}>
              Return to Dashboard
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;